module.exports = __webpack_public_path__ + "static/media/our-roofless-home.553c2388.mp3";